// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SmallTalkHeader__smallTalkHeader___19btL{padding:15px 16px;padding-top:20px;border-bottom:1px solid #EEE;display:flex;align-items:center}.SmallTalkHeader__smallTalkHeaderIcon___1YyOh{width:24px;height:12px;background-color:#134696;border-radius:8px;margin-right:8px}\n", ""]);
// Exports
exports.locals = {
	"smallTalkHeader": "SmallTalkHeader__smallTalkHeader___19btL",
	"smallTalkHeaderIcon": "SmallTalkHeader__smallTalkHeaderIcon___1YyOh"
};
module.exports = exports;
